export default [
  // 修改持卡人信息
  {
    name: 'stord-card-mgr-modify-info',
    component: () => import(/* webpackChunkName: "stord-card-mgr-modify-info" */ './modify-info.vue'),
  },
  // 手动扣费
  {
    name: 'stored-card-deduct-cost',
    component: () => import(/* webpackChunkName: "stored-card-deduct-cost" */ './deduct-cost.vue'),
  },
  // 批量修改有效期
  {
    name: 'stored-card-batch-md-expire',
    component: () => import(/* webpackChunkName: "stored-card-batch-md-expire" */ './batch-md-expireday.vue'),
  },
];
